<template>
  <nav class="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-lg shadow-md pt-safe">
    <div class="flex items-center justify-between h-14 px-4">
      <!-- Brand -->
      <router-link to="/home" class="flex items-center gap-2">
        <img src="@/assets/earth.png" alt="iCollect Logo" class="w-8 h-8" />
        <span class="text-lg font-bold text-gray-800">iCollect{{ title }}</span>
      </router-link>

      <!-- Hamburger Button (Mobile) -->
      <button
        class="lg:hidden w-14 h-14 flex flex-col items-center justify-center gap-1.5 -mr-4 transition-colors hover:bg-gray-100"
        :aria-expanded="isActive"
        aria-label="menu"
        @click="toggleMenu"
      >
        <span
          class="block w-5 h-0.5 bg-gray-700 rounded transition-all duration-300"
          :class="{ 'rotate-45 translate-y-2': isActive }"
        ></span>
        <span
          class="block w-5 h-0.5 bg-gray-700 rounded transition-all duration-300"
          :class="{ 'opacity-0': isActive }"
        ></span>
        <span
          class="block w-5 h-0.5 bg-gray-700 rounded transition-all duration-300"
          :class="{ '-rotate-45 -translate-y-2': isActive }"
        ></span>
      </button>

      <!-- Desktop Menu -->
      <div class="hidden lg:flex items-center gap-2">
        <router-link
          to="/home"
          class="flex items-center gap-2 px-4 py-2 text-gray-700 font-medium rounded-lg hover:bg-gray-100 transition-colors"
        >
          <i class="fas fa-home text-gray-500"></i>
          <span>Home</span>
        </router-link>
        <button
          @click="logout"
          class="flex items-center gap-2 px-4 py-2 text-red-600 font-medium rounded-lg hover:bg-red-50 transition-colors"
        >
          <i class="fas fa-sign-out-alt"></i>
          <span>Logout</span>
        </button>
      </div>
    </div>

    <!-- Mobile Menu Overlay -->
    <transition name="fade">
      <div
        v-if="isActive"
        class="lg:hidden fixed inset-0 top-14 bg-black/50 z-40"
        @click="closeMenu"
      ></div>
    </transition>

    <!-- Mobile Menu Drawer -->
    <div
      class="lg:hidden fixed top-14 right-0 w-72 h-[calc(100vh-3.5rem)] bg-white shadow-xl z-50 transition-transform duration-300 ease-out"
      :class="isActive ? 'translate-x-0' : 'translate-x-full'"
    >
      <div class="flex flex-col py-4">
        <router-link
          to="/home"
          @click="closeMenu"
          class="flex items-center gap-3 px-6 py-4 text-gray-700 font-medium border-b border-gray-100 hover:bg-gray-50 transition-colors"
        >
          <i class="fas fa-home text-gray-500 w-6"></i>
          <span>Home</span>
        </router-link>
        <button
          @click="logout"
          class="flex items-center gap-3 px-6 py-4 text-red-600 font-medium hover:bg-red-50 transition-colors text-left"
        >
          <i class="fas fa-sign-out-alt w-6"></i>
          <span>Logout</span>
        </button>
      </div>
    </div>
  </nav>
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  setup() {
    const isActive = ref(false);
    const store = useStore();
    const router = useRouter();

    const toggleMenu = () => {
      isActive.value = !isActive.value;
    };

    const closeMenu = () => {
      isActive.value = false;
    };

    const logout = () => {
      closeMenu();
      sessionStorage.clear();
      store.commit("SET_TOKEN", null);
      store.commit("SET_USER", null);
      router.push({ name: "login" });
    };

    return {
      toggleMenu,
      closeMenu,
      logout,
      isActive,
    };
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Safe area top padding */
.pt-safe {
  padding-top: env(safe-area-inset-top);
}
</style>
